import {Vraag, VraagDto} from './vraag';

export class Signaalkaart {

  static deserialize(dto: SignaalkaartDto): Signaalkaart {
    return new Signaalkaart(
      dto.id,
      dto.versie,
      dto.titel,
      dto.icoon,
      dto.categorie,
      dto.vragen
        .map(vraagDto => Vraag.deserializeToType(vraagDto))
        .filter(vraag => !!vraag),
      dto.uitleg
    );
  }

  constructor(private id: string,
              private versie: number,
              private titel: string,
              private icoon: string,
              private categorie: string,
              private vragen: Array<Vraag> = [],
              private uitleg?: string
  ) {
  }

  getId(): string {
    return this.id;
  }

  hasId(id: string): boolean {
    return this.getId() === id;
  }

  getVersie(): number {
    return this.versie;
  }

  hasVersie(versie: number): boolean {
    return this.versie === versie;
  }

  getTitel(): string {
    return this.titel;
  }

  getIcoon(): string {
    return this.icoon;
  }

  getCategorie(): string {
    return this.categorie;
  }

  getVragen(): Array<Vraag> {
    return this.vragen;
  }

  getUitleg(): string | undefined {
    return this.uitleg;
  }

  hasUitleg(): boolean {
    return !!this.uitleg;
  }
}

export interface SignaalkaartDto {
  id: string;
  versie: number;
  titel: string;
  icoon: string;
  categorie: string;
  vragen: Array<VraagDto>;
  uitleg: string;
}
